const mutations = {
    updateIsNage(state, data) {
        state.isNag = data;
    },
    updateBanner(state, data) {
        state.banner = data;
    },
    updateName(state, data) {
        state.name = data;
    },
    updateMy_menu(state, data) {
        state.my_menu = data;
    },
}
export default mutations


// WEBPACK FOOTER //
// ./src/store/indexData/mutations.js